import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Modal, Row} from 'reactstrap';

// components
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import {GenericButton} from "../../../../components/buttons/customButtons";

// labels
import { INTERNATIONAL, LB_ACTIVE, LB_CODE } from "../../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_REMOVE, TT_SAVE} from "../../../../components/i18n/toolTips";
import {PH_CODE, PH_ICON} from "../../../../components/i18n/placeHolders";
import {
    FL_ICON,
} from "../../../../components/i18n/formLabels";

// actions

// providers

// utils
import { getCurrentDateForCodeField } from "../../../../util/DateTools";

// services
import SubCategorySectionLangs from "./_langs";
import Separator from "../../../../components/Separator";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {hotelCategoryService} from "../../../../jwt/_services/hotel/hotelCategoryService";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {hotelActivityService} from "../../../../jwt/_services/hotel/hotelActivityService";

export const SubCategorySectionForm = forwardRef((props, ref) => {
    const path = props.path;
    const [udn] = useState(props.udn || null);
    const [app] = useState(props.app || null);

    const [domainObject, setDomainObject] = useState(null);
    const [translatableLangs, setTranslatableLangs] = useState( []);

    const [status, setStatus] = useState( false)
    const [parentId, setParentId] = useState( null);
    const [langs, setLangs] = useState( []);
    const [code, setCode] = useState( '');
    const [icon, setIcon] = useState( '');
    const [navigationUrl, setNavigationUrl] = useState( '' );

    const [modal, setModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [showOrder, setShowOrder] = useState(0);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    useImperativeHandle(ref, () => ({
        showModal(_item, _index, _category) {
            const autocode = `${udn?.code}_cat_` + getCurrentDateForCodeField();

            console.log('index:', (_item?.priority || _index || 0))

            setDomainObject( _item );
            setEditMode( !!_item?.id );
            setCode(_item?.code || autocode.toUpperCase());
            setShowOrder( (_item?.showOrder || _index || 0) );
            setIcon(_item?.icon || '');
            setLangs(_item?.langs || []);
            setTranslatableLangs(_item?.translatedLangs || [])
            setStatus(_item?.id ? _item?.status : true );
            setParentId(_item?.category?.id || _category?.id || null);
            setModal(!modal);
        }
    }));

    const onSubmit = (_) => {
        const dataRequest = {
            fbDataBase : {id: app?.fbDataBase?.id},
            item: {
                code,
                icon: 'ic_ftvm',
                navigationUrl,
                status,
                priority: (showOrder + 1),
                showInHome: false,
                udn: { id: udn?.id },
                parent : { id: parentId },
                langs,
            }
        }

        if (!editMode) {
            // console.log('save',  dataRequest);
            // return;
            genericIndexedActions.save(path, hotelCategoryService, dataRequest)
        }
        else {
            let id = domainObject.id;
            dataRequest.item.id = domainObject?.id

            // console.log('update',  dataRequest);
            // return;
            genericIndexedActions.update(path, hotelCategoryService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        setModal(!modal);
    }

    const onRemoveItem = (item) => {
        genericIndexedActions.delete(path, hotelCategoryService, item.id, app?.fbDataBase?.id, closeForm);
    }

    return <>
        <Modal isOpen={modal} toggle={setModal} modalClassName="menu-modal-form-medium">
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                    <br />
                    <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                </>
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        onClick={onSubmit}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        </>
                    }
                    <TranslateButton item={domainObject} service={hotelCategoryService}  askForConfirmation={false}/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-trash'}
                        permission={'delete'}
                        onClick={() => onRemoveItem(domainObject)}
                    />
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Input
                        type="hidden"
                        name="code"
                        value={code}
                        onChange={e => setCode(e.target.value)}
                        placeholder={PH_CODE}
                        // className={(errors.code ? ' is-invalid' : '')}
                    />
                    {/*<Col md="4">*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>{LB_CODE}</Label>*/}
                    {/*        <Input*/}
                    {/*            type="text"*/}
                    {/*            name="code"*/}
                    {/*            value={code}*/}
                    {/*            onChange={e => setCode(e.target.value)}*/}
                    {/*            placeholder={PH_CODE}*/}
                    {/*            // className={(errors.code ? ' is-invalid' : '')}*/}
                    {/*        />*/}
                    {/*        /!*{ errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}*!/*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                    {/*<Col md="4">*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>{FL_ICON}</Label>*/}
                    {/*        <Input*/}
                    {/*            type="text"*/}
                    {/*            name="icon"*/}
                    {/*            value={icon}*/}
                    {/*            onChange={e => setIcon(e.target.value)}*/}
                    {/*            placeholder={PH_ICON}*/}
                    {/*        />*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                    <Col md="6">
                        <FormGroup>
                            <Label>{'Url de navegación (Opcional)'}</Label>
                            <Input
                                type="text"
                                name="navigationUrl"
                                placeholder={'Url de navegación'}
                                value={navigationUrl}
                                onChange={e => setNavigationUrl(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{LB_ACTIVE}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={() => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <div className={'form-container'}>
                    <div className={''}>
                        <h2>{INTERNATIONAL}</h2>
                    </div>
                    <div className={''}>
                        <Row>
                            <SubCategorySectionLangs
                                langs={langs}
                                setLangs={setLangs}
                                translatableLangs={translatableLangs}
                            />
                        </Row>
                    </div>
                </div>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={modalRef}
                    item={domainObject}
                />
            }
        </Card>
        </Modal>
    </>
})
